module.exports = __webpack_public_path__ + "static/images/pressed-cursor.21YozO8.png";